<div class="layout-dashboard card" pCard>
    <div class="grid">
        <div class="col-12 xl:col-12">
            <div>
                <div
                    class="flex w-full justify-content-between align-items-center mb-4"
                >
                    <div class="flex align-items-start gap-3">
                        <img
                            class="title-image"
                            src="../../../../assets/demo/order.gif"
                        />
                        <div class="flex flex-column pt-1">
                            <h4 class="mb-0 pb-0">
                                {{ "MY_INSURANCE_ORDERS" | translate }}
                            </h4>
                            <small class="list-stats"
                                >{{ openOrdersCount }}
                                {{ "open orders" | translate }}</small
                            >
                        </div>
                    </div>
                </div>
                <p-table
                    *ngIf="
                        getDeviceType() === 'desktop' ||
                        getDeviceType() === 'tablet'
                    "
                    [value]="orders"
                    [paginator]="true"
                    [rows]="10"
                    responsiveLayout="scroll"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{ "Order Date" | translate }}</th>
                            <th>{{ "Number of Items" | translate }}</th>
                            <th>{{ "Expiry Date" | translate }}</th>
                            <th>{{ "STATUS" | translate }}</th>
                            <th>{{ "Total Amount" | translate }}</th>
                            <th>{{ "Actions" | translate }}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-order>
                        <tr [ngClass]="rowClass(order)">
                            <td>
                                <span class="p-column-title">Order Date</span>
                                {{
                                    order.orderDate
                                        | date : "dd-MMM-yyyy HH:mm:ss"
                                }}
                            </td>
                            <td>
                                <span class="p-column-title"
                                    >Number of Items</span
                                >
                                {{ order.numberOfItems }}
                            </td>
                            <td>
                                <span class="p-column-title">Expiry Date</span>
                                {{
                                    order.expiryDate
                                        ? (order.expiryDate
                                          | date : "dd-MMM-yyyy")
                                        : "---"
                                }}
                            </td>
                            <td>
                                <span class="p-column-title">Status</span>
                                {{ order.status | translate }}
                            </td>
                            <td>
                                <span class="p-column-title">Total Amount</span>
                                {{ order.total | currency : "MZN " }}
                            </td>
                            <td>
                                <p-button
                                    class="table-button"
                                    [pTooltip]="'VIEW_ORDER' | translate"
                                    icon="pi pi-info-circle"
                                    [rounded]="true"
                                    [text]="true"
                                    (onClick)="viewOrderDetails(order)"
                                    severity="info"
                                />
                            </td>
                            <td>
                                <p-button
                                    *ngIf="order.status === 'OPEN'"
                                    (click)="delete(order.id)"
                                    class="table-button cancel-order"
                                    [pTooltip]="'CANCEL_ORDER' | translate"
                                    icon="pi pi-trash"
                                    [rounded]="true"
                                    [text]="true"
                                    [style]="{ 'background-color': 'white' }"
                                    severity="danger"
                                />
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <div *ngIf="getDeviceType() === 'mobile'">
                    <app-order-list-card
                        (click)="viewOrderDetails(order)"
                        [order]="order"
                        *ngFor="let order of orders"
                    ></app-order-list-card>
                </div>
            </div>
        </div>
    </div>
</div>
